import { ReactNode } from "react";
import { CookieProvider } from "~/components/utils/useCookies";
import { NavShowingProvider } from "./NavShowingProvider";
import { NewsletterProvider } from "./NewsletterProvider";
import { PageTransitionProvider } from "./PageTransitionProvider";
import { ScrollLockProvider } from "./ScrollLockProvider";

export default function RootProvider({ children }: { children: ReactNode }) {
  return (
    <ScrollLockProvider>
      <NavShowingProvider>
        <PageTransitionProvider>
          <NewsletterProvider>
            <CookieProvider>{children}</CookieProvider>
          </NewsletterProvider>
        </PageTransitionProvider>
      </NavShowingProvider>
    </ScrollLockProvider>
  );
}
